//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState } from 'react';

import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button,
  InputLabel,
  Modal,
  Typography,
} from '@mui/material';

// === API ===
import { assignFile } from 'api/prokey/prokey.websocket';

import { UserSelect } from 'components/UserSelect/index';

//#endregion

//-----------------------------------------------------------------
export function AssignUserModal(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const theme = useTheme();

  const [ user , setUser ] = useState( '' );
  
  // === STYLE ===
  const _styles = {
    container: { 
      position       : 'absolute',
      top            : '25%',
      left           : '50%',
      transform      : 'translate(-50%, -50%)',
      width          : 400,
      boxShadow      : 24,
      padding        : '1rem',
      alignText      : 'center',
      justifyContent : 'center',
      backgroundColor : theme.palette.background.secondary[theme.palette.mode],
    },
    header: {
      marginBottom: '0.5rem',
      width: '50%',
    },
    control_container: {
      display        : 'flex'   ,
      justifyContent : 'center' ,
      marginTop      : '0.5rem' ,
    },
    user_select: {
      width       : '100%',
      marginRight : '1rem',
    },
    assign_button: {
      // width       : '5rem' ,
      height      : '4rem' ,
      marginRight : '1rem',
      marginLeft  : '1rem',
    }
  };

  // === ATTRIBUTES ===
  const ASSIGN_BUTTON = {
    sx       : _styles.assign_button,
    variant  : 'contained',
    color    : 'primary',
    onClick  : handleAssignUser,
  }
  const HEADER = {
    sx        : _styles.header,
    id        : "modal-modal-title",
    variant   : "h6",
    component : "h2",
    children  : ['Assign User'],
  }
  const CONTROL_CONTRAINER = {
    sx : _styles.control_container,
  }

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function handleAssignUser() {
    //-----------------------------------------------------------------
    try {
      Object.keys( props.files ).map( file_id => assignFile( user, file_id) );
      props.onClose()
    } catch (error) {
      console.warn(error);      
    }
  }
  
  //-----------------------------------------------------------------
  function handleUserChange( user_id ) {
    //-----------------------------------------------------------------
    setUser( user_id[0] );
  };

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Modal open={props.is_open} onClose={ props.onClose }>
        <Box sx={_styles.container}>
          <Typography { ...HEADER } />
          {/* <InputLabel id="user-select-label">Username</InputLabel> */}
          <Box { ...CONTROL_CONTRAINER } >
            <UserSelect onChange={handleUserChange} />
            <Button {...ASSIGN_BUTTON}>Assign</Button>
          </Box>
        </Box>
      </Modal>
    );
  }

  //#endregion

  return display();
}